var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "payment-blocked" }, [
    _c("div", { staticClass: "payment-blocked__inner" }, [
      _c("div", { staticClass: "payment-blocked__card" }, [
        _vm._m(0),
        _c("h1", { staticClass: "payment-blocked__title" }, [
          _vm._v(_vm._s(_vm.$t("payment_blocked.title"))),
        ]),
        _c("p", { staticClass: "payment-blocked__subtitle" }, [
          _vm._v(_vm._s(_vm.$t("payment_blocked.subtitle"))),
        ]),
        _c("p", { staticClass: "payment-blocked__hint" }, [
          _vm._v(_vm._s(_vm.$t("payment_blocked.hint"))),
        ]),
        _c(
          "button",
          {
            staticClass: "payment-blocked__btn-support",
            on: { click: _vm.contactSupport },
          },
          [
            _c("i", { staticClass: "fa-regular fa-headset" }),
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("payment_blocked.contact_support")) +
                "\n      "
            ),
          ]
        ),
        _c("div", { staticClass: "payment-blocked__check-status" }, [
          _vm.isChecking
            ? _c("span", {
                staticClass:
                  "payment-blocked__check-dot payment-blocked__check-dot--active",
              })
            : _c("span", { staticClass: "payment-blocked__check-dot" }),
          _c("span", { staticClass: "payment-blocked__check-label" }, [
            _vm._v(
              "\n          " +
                _vm._s(
                  _vm.isChecking
                    ? _vm.$t("payment_blocked.checking")
                    : _vm.$t("payment_blocked.check_label")
                ) +
                "\n        "
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "payment-blocked__icon-wrapper" }, [
      _c("i", {
        staticClass: "fa-regular fa-clock-rotate-left payment-blocked__icon",
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }